export default {
  ['loading']: state => state.loading,
  ['projectTypes']: state => state.projectTypes,
  ['brandDetectionModels']: state => state.brandDetectionModels,
}
